<style scoped lang="scss">
    video {
        width: 300px;
        height: 225px;
        background-color: #000000;
    }

    ul {
        flex-wrap: wrap;

        li {

        }
    }
</style>
<template>
    <el-card class="box-card container">
        <div slot="header" class="oh">
            <span>房间号：</span>
            <div style="float: right;">
                <el-button type="warning" size="mini" @click="handler('start')">开启直播</el-button>
                <el-button type="success" size="mini" @click="ppt">PPT分享</el-button>
                <el-button type="primary" size="mini" @click="handler('quit')">退出直播</el-button>
            </div>
        </div>
        <div class="flex">
            <div class="flex0">
                <div class="fs16 pb15">从下面设备列表中选择画中画视频</div>
                <ul class="flex">
                    <li class="mr15 pb15">
                        <video autoplay controls ref="local"></video>
                        <p class="fs12 color_666">本机</p>
                    </li>
                    <video-item v-for="(info,idx) in videos" :key="idx" :info="info"></video-item>
                </ul>
            </div>
            <div class="flex1"></div>
        </div>
    </el-card>
</template>

<script>
  import {liveTee3Mixin} from "../../lib/video/liveTee3Mixin";
  import VideoItem from "../../components/live/video-item";

  export default {
    name: "Detail",
    components: {VideoItem},
    mixins: [liveTee3Mixin],
    data() {
      return {}
    },
    created() {
      bus.$once('leaveSuccess', () => {
        this.$router.back();
      });

    },
    methods: {
      handler(type, data) {
        if (type === 'console') {
          this.$router.push({
            path: '/other/live/console',
            query: {room: data.room}
          })
        } else if (type === 'quit') {
          this.$confirm('此操作将退出直播, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.closeAll();
          })
        } else if (type === 'start') {
          this.$confirm('该直播还没有接入高清设备, 是否继续?', '提示', {
            confirmButtonText: '直接开启',
            cancelButtonText: '接入高清设备',
            type: 'warning'
          }).then(() => {

          }).catch(() => {
            this.callSip();
          })
        }
      }
    },
  }
</script>

